import { defineComponent as _defineComponent } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Sidebar from 'primevue/sidebar';
import Calendar from 'primevue/calendar';
import LeavesEdit from './EditCreate.vue';
import { computed, onMounted, ref } from 'vue';
import { DateTime } from 'luxon';
import { Inertia } from '@inertiajs/inertia';
import { useMitt } from '../../../Plugins/mitt';
import { concatPlotsCodes, formatISODate } from '../../../Services/Utils';
import RecordsTableHeader from '../../../Components/RecordsTableHeader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const selectedRecords = ref([]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            id: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            plots: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code', 'plots', 'description'];
        const visibleRightEdit = ref(false);
        const page = usePage();
        const leavesDatas = computed(() => page.props.value.leavesDatas || []);
        const reloadRecords = () => Inertia.reload({
            only: ['leavesDatas'],
        });
        onMounted(() => {
            reloadRecords();
        });
        const edit = (data) => emitter.emit('open-leaves-data-form', data);
        emitter.on('leaves-data-saved', () => reloadRecords());
        const __returned__ = { emitter, selectedRecords, filters, globalFilterFields, visibleRightEdit, page, leavesDatas, reloadRecords, edit, get InputText() { return InputText; }, get Button() { return Button; }, DataTable, get Column() { return Column; }, get Sidebar() { return Sidebar; }, get Calendar() { return Calendar; }, LeavesEdit, get concatPlotsCodes() { return concatPlotsCodes; }, get formatISODate() { return formatISODate; }, RecordsTableHeader };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
